export default __webpack_public_path__ + "static/media/FO.5c874a7d.svg";